import axiosInstance from '../apiService';
import constants from '../../constants/constants';

const ENDPOINTORIGIN = 'Licensor/';

const getAllLicensors = async (isActive) => axiosInstance.get(`${ENDPOINTORIGIN}GetAllLicensors?isActive=${isActive}`, constants.REQUIRE_INTERCEPTORS);

const getLicensorById = async (licensorId) => axiosInstance.get(`${ENDPOINTORIGIN}GetLicensorById?licensorId=${licensorId}`, constants.REQUIRE_INTERCEPTORS);

const createLicensor = async (licensor) => axiosInstance.post(`${ENDPOINTORIGIN}CreateLicensor`, licensor, constants.REQUIRE_INTERCEPTORS);

const updateLicensor = async (model) => axiosInstance.put(`${ENDPOINTORIGIN}UpdateLicensor`, model, constants.REQUIRE_INTERCEPTORS);

const deleteLicensor = async (id) => axiosInstance.delete(`${ENDPOINTORIGIN}DeleteLicensor?id=${id}`, constants.REQUIRE_INTERCEPTORS);

export {
  getAllLicensors,
  getLicensorById,
  createLicensor,
  updateLicensor,
  deleteLicensor,
};